// extracted by mini-css-extract-plugin
export var addToLibraryRow = "PDFViewer-module--addToLibraryRow--00b09";
export var arrow = "PDFViewer-module--arrow--5e0fc";
export var arrowNo = "PDFViewer-module--arrow_no--fbb9b";
export var arrowYes = "PDFViewer-module--arrow_yes--abbd7";
export var closeOverlayButton = "PDFViewer-module--closeOverlayButton--bbe48";
export var closeOverlayIcon = "PDFViewer-module--closeOverlayIcon--050b4";
export var currentPageIndicator = "PDFViewer-module--currentPageIndicator--b4f78";
export var disabled = "PDFViewer-module--disabled--fcccb";
export var documentImage = "PDFViewer-module--documentImage--450fd";
export var documentInformationColumn = "PDFViewer-module--documentInformationColumn--0be27";
export var documentInformationContainer = "PDFViewer-module--documentInformationContainer--ffb9d";
export var documentTitle = "PDFViewer-module--documentTitle--868e0";
export var downloadContainer = "PDFViewer-module--downloadContainer--48a06";
export var downloadDocumentButton = "PDFViewer-module--downloadDocumentButton--7eabe";
export var fileInformation = "PDFViewer-module--fileInformation--251f0";
export var flex = "PDFViewer-module--flex--e9ed5";
export var flex1 = "PDFViewer-module--flex_1--4379a";
export var flexCenter = "PDFViewer-module--flex_center--8998a";
export var flexCenterCol = "PDFViewer-module--flex_center_col--386ec";
export var flexCol = "PDFViewer-module--flex_col--5ebc4";
export var flexFixCenterCol = "PDFViewer-module--flex_fix_center_col--a14fe";
export var flexFixedCenterCol = "PDFViewer-module--flex_fixed_center_col--a50c9";
export var informationItem = "PDFViewer-module--informationItem--8cc0a";
export var informationItemLabel = "PDFViewer-module--informationItemLabel--c77ee";
export var mobile = "PDFViewer-module--mobile--3a451";
export var navigationButton = "PDFViewer-module--navigationButton--72510";
export var nextPageButton = "PDFViewer-module--nextPageButton--8f3ee";
export var nextPageIcon = "PDFViewer-module--nextPageIcon--f65cc";
export var pageControlContainer = "PDFViewer-module--pageControlContainer--e8442";
export var pdfContentContainer = "PDFViewer-module--pdfContentContainer--8f8fe";
export var pdfControlsContainer = "PDFViewer-module--pdfControlsContainer--8a0ac";
export var pdfDocumentButtons = "PDFViewer-module--pdfDocumentButtons--8cecd";
export var pdfScrollWrapper = "PDFViewer-module--pdfScrollWrapper--a2509";
export var pdfViewer = "PDFViewer-module--pdfViewer--bff24";
export var pdfViewerContainer = "PDFViewer-module--pdfViewerContainer--3951f";
export var previousPageButton = "PDFViewer-module--previousPageButton--7461c";
export var previousPageIcon = "PDFViewer-module--previousPageIcon--53d16";
export var printDocumentButton = "PDFViewer-module--printDocumentButton--0ea80";
export var printDocumentButtonTitle = "PDFViewer-module--printDocumentButtonTitle--19a3b";
export var rotating = "PDFViewer-module--rotating--81179";
export var visible = "PDFViewer-module--visible--7c01b";
export var zoomControlIcon = "PDFViewer-module--zoomControlIcon--136a4";
export var zoomControls = "PDFViewer-module--zoomControls--e3c72";